import React from "react";
import { useSubscription } from "@apollo/client";
import gql from "graphql-tag";
import { pickBy, identity } from "lodash";

export const OnUserUpdatedSubscription = ({ userId }) => {
  useSubscription(subscription, {
    variables: {
      userId,
    },
    onSubscriptionData: ({ client: { cache }, subscriptionData }) => {
      // Try updating the root user query, if it exists, and is the same user

      const updatedUserData = subscriptionData?.data?.onSSOUserUpdated;
      const scrubbedUpdatedData = pickBy(updatedUserData, identity);

      const prevData = cache.readQuery({ query: rootUserQuery });

      if (
        prevData?.user?.id !== undefined &&
        prevData?.user?.id === scrubbedUpdatedData?.id
      ) {
        // Update the current users info with values from subscription

        const updatedData = {
          ...prevData,
          user: {
            ...prevData.user,
            ...scrubbedUpdatedData,
          },
        };

        cache.writeQuery({ query: rootUserQuery, data: updatedData });
      }
    },
  });
  return <></>;
};

const subscription = gql`
  subscription onSSOUserUpdated($userId: String) {
    onSSOUserUpdated(userId: $userId) {
      id
      email
      password
      createdAt
      updatedAt
      lastSignin
      passwordResetValue
      token
      roles
      status
      name
      passwordChangedAt
      accountRole
      accountId
      accepted
    }
  }
`;

const rootUserQuery = gql`
  query {
    user {
      id
      email
      name
      passwordChangedAt
      createdAt
    }
  }
`;
